
import {AuthProvider} from './auth';
import {ChatProvider} from './chat';
import {VideoCallProvider} from './videoCall';
import {NotificationProvider} from './notification';
export const ContextProvider = (props) => {

  const {children} = props;

  return (
    <AuthProvider>
      <NotificationProvider>
        <ChatProvider>
          <VideoCallProvider>
            {children}
          </VideoCallProvider>
        </ChatProvider>
      </NotificationProvider>
    </AuthProvider>
  );
};